<template>
  <div class="container-fluid">
    <div class="row flex-row">
      <div v-if="rule._id" class="col-xl-3">
        <!-- Begin Widget -->
        <div class="widget has-shadow">
          <div class="widget-body">
            <h3 class="text-center mt-3 mb-1">{{ rule.title }}</h3>
            <p class="text-center">{{ rule.isAvailable ? 'فعال' : 'غیر فعال' }}</p>
            <div class="em-separator separator-dashed"></div>
          </div>
        </div>
        <!-- End Widget -->
      </div>
      <div class="col-xl-9">
        <div class="widget has-shadow">
          <div class="widget-header bordered no-actions d-flex align-items-center">
            <h4>اطلاعات قانون</h4>
          </div>
          <div class="widget-body">
            <form id="groupForm" class="form-horizontal">
              <!-- group name -->
              <div class="form-group row d-flex align-items-center mb-5">
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end">نام قانون</label>
                <div class="col-lg-6">
                  <input type="text" name="groupName" class="form-control" v-model="rule.title" />
                </div>
              </div>

              <!-- is black List -->
              <div class="form-group row d-flex align-items-center mb-5">
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end">نوع دسترسی</label>
                <div class="col-lg-6">
                  <select class="form-control" name="isLevelBased" id="" v-model="rule.isBlackList">
                    <option value="" disabled>انتخاب کنید</option>
                    <option :value="true">Black List</option>
                    <option :value="false">White List</option>
                  </select>
                </div>
              </div>

              <!-- is black List -->
              <div class="form-group row d-flex align-items-center mb-5">
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end"
                  >در همه گروه های انتخابی باشد؟</label
                >
                <div class="col-lg-6">
                  <select class="form-control" name="isOrLogicActive" id="" v-model="rule.isOrLogicActive">
                    <option value="" disabled>انتخاب کنید</option>
                    <option :value="true"> در یک گروه باشد کافی است</option>
                    <option :value="false">در همه گروه ها باید باشد</option>
                  </select>
                </div>
              </div>

              <!-- is Available -->
              <div class="form-group row d-flex align-items-center mb-5">
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end">وضعیت قانون</label>
                <div class="col-lg-6">
                  <select class="form-control" name="isLevelBased" id="" v-model="rule.isAvailable">
                    <option value="" disabled>انتخاب کنید</option>
                    <option :value="true">فعال</option>
                    <option :value="false">غیر فعال</option>
                  </select>
                </div>
              </div>

              <!-- groups -->

              <div class="form-group row d-flex align-items-center mb-5">
                <label class="col-lg-2 form-control-label d-flex justify-content-lg-end">گروه ها</label>
                <div class="col-lg-6">
                  <select class="form-control" name="isLevelBased" id="" v-model="rule.groups" multiple>
                    <option value="" disabled>انتخاب کنید</option>
                    <option v-for="group in groups" :key="group._id" :value="group._id">{{ group.title }}</option>
                  </select>
                </div>
              </div>
            </form>
            <div class="em-separator separator-dashed"></div>
            <div class="text-right">
              <button class="btn btn-gradient-01" @click="save">ذخیره تغییرات</button>
              <router-link class="btn btn-shadow" to="/dashboard/UserRules">بازگشت</router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import groupService from '../../../../services/UsersRulePermissions';
export default {
  name: 'groupdetail',
  data() {
    return {
      rule: {
        groups: [],
      },
      groups: [],
      id: null,
    };
  },
  created() {
    this.getGroups();
    if (this.$route.query.id) {
      this.id = this.$route.query.id;
      this.getRule(this.id);
    }
  },
  methods: {
    async getGroups() {
      try {
        const resData = await groupService.getGroups({});
        this.groups = resData;
      } catch (err) {
        console.log(err);
      }
    },
    async getRule(id) {
      try {
        const rule = await groupService.getRule(id);
        this.rule = rule;
      } catch (err) {
        console.log(err);
      }
    },
    async save() {
      const body = this.rule;
      let id;
      try {
        if (this.id) {
          await groupService.editRule(body);
          id = this.id;
          window.notif({ mssg: 'تغییرات انجام شد', isError: false });
        } else {
          const group = await groupService.addRule(body);
          id = group._id;
          this.id = id;
          window.notif({ mssg: 'گروه جدید با موفقیت ساخته شد', isError: false });
        }

        this.getRule(id);
      } catch (err) {
        window.notif({ mssg: 'مشکلی پیش آمده', isError: true });
      }
    },
  },
};
</script>
